<template>
  <div class="box15">
    <div class="left">
      <div class="title">产品经理学习路线图</div>

      <div class="btn" @click="goHref('免费领取')">免费领取</div>
    </div>
    <div class="right"></div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },

  mounted() {},
  methods: {
    goHref() {
      window.open("https://m.boxuegu.com/route/pm");
        this.mai("产品经理-就业课","免费领取",0,null)
      // this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box15 {
  position: relative;

  width: 100%;
  height: 230px;
  background: url("../../../assets/coursePage/pm/box15/bgc.png") no-repeat;
  background-size: cover;
  background-position-x: center;
  box-sizing: border-box;
  overflow: hidden;
  .left {
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 40px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: #191c47;
      margin: 49px 0 36px 51px;
    }
    .btn {
      margin-left: 51px;
      display: flex;
      justify-content: center;
      align-items: center;

      width: 160px;
      height: 56px;
      background-image: linear-gradient(90deg, #443eff 0%, #5d58ff 100%);
      border-radius: 8px;
      text-align: center;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 56px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }

  .right {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 312px;
    height: 216px;
    background: url("../../../assets/coursePage/pm/box15/icon.png") no-repeat;
    background-size: cover;
  }
}
</style>
